<template>
    <transition name="fade">
        <span class="text-danger">
        <slot></slot>
    </span>
    </transition>
</template>

<script>
    export default {}
</script>

<style scoped>
    .fade-enter-active {
        transition: opacity .2s;
    }
    .fade-enter/* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>